const audioGraphs = new WeakMap();

function getMediaElement(player) {
  if (!player) {
    return null;
  }

  if (player.tagName === 'VIDEO' || player.tagName === 'AUDIO') {
    return player;
  }

  if (typeof player.getInternalPlayer === 'function') {
    return player.getInternalPlayer();
  }

  return player;
}

export function applyVolumeBoost(player, percent) {
  const mediaEl = getMediaElement(player);
  if (!mediaEl) {
    return;
  }

  const gainValue = Math.max(0, Number(percent) / 100);
  if (Number.isNaN(gainValue)) {
    return;
  }

  if (gainValue <= 1) {
    mediaEl.volume = gainValue;
    const existing = audioGraphs.get(mediaEl);
    if (existing) {
      existing.gainNode.gain.value = 1;
    }
    return;
  }

  mediaEl.volume = 1;

  let graph = audioGraphs.get(mediaEl);
  if (!graph) {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      const ctx = new AudioContextClass();
      const sourceNode = ctx.createMediaElementSource(mediaEl);
      const gainNode = ctx.createGain();
      sourceNode.connect(gainNode);
      gainNode.connect(ctx.destination);
      graph = { ctx, gainNode };
      audioGraphs.set(mediaEl, graph);
    } catch (error) {
      mediaEl.volume = 1;
      return;
    }
  }

  if (graph.ctx.state === 'suspended') {
    graph.ctx.resume();
  }

  graph.gainNode.gain.value = gainValue;
}
